/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, borderRadius } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { media } from '@atlassian/bitkit-responsive';

import PullRequestLink from 'src/components/pull-request-link';
import RepositoryLink from 'src/components/repository-link';
import { overflowEllipsis, subtleLink } from 'src/styles/mixins';

export const Activity = styled.div({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-start',
});

export const Arrow = styled.span({
  color: token('color.text.subtlest'),
  display: 'flex',
  margin: `0 ${gridSize() / 2}px`,
});

export const BranchesContainer = styled.span(
  {
    display: 'flex',
    alignItems: 'center',
    marginLeft: `${gridSize()}px`,
  },
  media.upToSmall(` margin-left: 0; `)
);

export const SourceBranch = styled.span(
  media.upToXLarge(` display: none; `),
  media.upToSmall(` display: block; `)
);

// Override AK's Tag's internal vertical margins
export const Branch = styled.span({
  '& span:only-child': {
    marginTop: 0,
    marginBottom: 0,
  },
});

export const AgeContainer = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const BuildStatusContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
});

export const HeaderLink = styled(PullRequestLink)({
  '&, &:hover, &:focus': {
    color: token('color.text'),
  },
});

export const SubtleRepositoryLink = styled(RepositoryLink)(subtleLink);

export const SummaryHeader = styled.div(
  {
    alignItems: 'center',
    display: 'flex',
    '> div': overflowEllipsis('100%'),
  },
  media.upToSmall(`
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
  `)
);

export const StateLozengeWrapper = styled.div({
  marginRight: `${gridSize()}px`,
  flexShrink: 0,
  '> *': {
    display: 'flex',
  },
});

export const TooltipBoundaries = styled.span({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const TableRow = styled.tr<{ isFocused?: boolean }>(props => ({
  backgroundColor: props.isFocused
    ? token('elevation.surface.raised')
    : 'initial',

  '&:hover, &:focus': {
    backgroundColor: token('elevation.surface.raised.hovered'),
    boxShadow: token('elevation.shadow.raised'),
    borderRadius: `${borderRadius()}px`,
  },
}));

export const Byline = styled.small({
  /* Prevents text upscale for small and wide elements in mobile Safafi, Edge and Chrome */
  textSizeAdjust: 'none',
  whiteSpace: 'normal',
});

export const BylineNoMargin = styled.small({
  /* Prevents text upscale for small and wide elements in mobile Safafi, Edge and Chrome */
  textSizeAdjust: 'none',
  whiteSpace: 'normal',
  margin: 0,
});
